import api from "./api";
import {
  CATEGORIES_URL,
  CATEGORIES_STORE_URL,
  categoryUrl,
  categoryUpdateUrl,
  categoryDeleteUrl,
} from "./api";

/**
 * Fetch every category.
 * GET /api/categories -> { success, message, data: [...] }
 */
export async function fetchCategories() {
  const res = await api.get(CATEGORIES_URL);
  const payload = res.data || {};
  const list = Array.isArray(payload.data) ? payload.data : [];
  // Keep them in their configured display order.
  return [...list].sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0));
}

/**
 * Fetch a single category by id.
 * GET /api/categories/{id}
 */
export async function fetchCategoryById(id) {
  const res = await api.get(categoryUrl(id));
  return res.data?.data;
}

/**
 * Create a category.
 * POST /api/categories-store (multipart/form-data — image is an actual file)
 * sort_order is NOT sent; the backend auto-assigns the next one.
 */
export async function createCategory({ name, status, imageFile }) {
  const fd = new FormData();
  fd.append("name", name ?? "");
  fd.append("status", status ? "1" : "0");
  if (imageFile instanceof File) {
    fd.append("image", imageFile);
  }
  const res = await api.post(CATEGORIES_STORE_URL, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

/**
 * Update a category.
 * POST /api/categories/update/{id} (multipart/form-data)
 * Only send `image` if the user actually picked a new file — leaving it
 * out tells the backend to keep the existing image.
 */
export async function updateCategory(id, { name, status, sort_order, imageFile }) {
  const fd = new FormData();
  fd.append("name", name ?? "");
  if (status !== undefined) fd.append("status", status ? "1" : "0");
  if (sort_order !== undefined && sort_order !== null) {
    fd.append("sort_order", sort_order);
  }
  if (imageFile instanceof File) {
    fd.append("image", imageFile);
  }
  const res = await api.post(categoryUpdateUrl(id), fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

/**
 * Delete a category.
 * GET /api/categories/delete/{id}  (yes, GET — matches the backend as documented)
 */
export async function deleteCategory(id) {
  const res = await api.get(categoryDeleteUrl(id));
  return res.data;
}
